import type { Question } from "../../types.js";
import type { Locale } from "./conceptCopy.js";
import { NOTANY_SEED_QUESTIONS_EL } from "./seedLocaleEl.js";

/** Apply Greek copy to NotAny seed MCQs; other locales keep canonical seed.ts rows. */
export function applyNotanySeedLocale(question: Question, locale: Locale): Question {
  if (locale !== "el") return question;
  const el = NOTANY_SEED_QUESTIONS_EL[question.id];
  if (!el) return question;
  return { ...question, text: el.text, options: el.options };
}
